import { useEffect } from 'react';
import { useMaisonAdjiCart } from '../context/MaisonAdjiCartContext';
import { buildMaisonAdjiPayLinkCheckoutUrl, getMaisonAdjiPayLinkCheckoutFallbackUrl } from '../lib/paylink';

/**
 * Redirection vers le checkout PayLink Maison Adji (username sokrate) avec panier complet (orderSummary, webhook, optional_data).
 */
export default function CheckoutMaisonAdjiPage() {
  const { items: maItems } = useMaisonAdjiCart();

  useEffect(() => {
    const url = maItems?.length
      ? buildMaisonAdjiPayLinkCheckoutUrl(
          maItems.map((i) => ({
            productId: i.productId,
            name: i.name,
            quantity: i.quantity,
            priceXof: i.priceXof,
            priceEur: i.priceEur,
            imageUrl: i.imageUrl,
          }))
        )
      : getMaisonAdjiPayLinkCheckoutFallbackUrl();
    window.location.href = url;
  }, [maItems]);

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
      <p className="font-['Rubik'] text-white/60">Redirection vers la caisse...</p>
    </div>
  );
}
